<template>
  <div class="tm-user-menu">
    <div class="tm-user-menu-avatar">
      <div>
        <div class="uk-grid uk-grid-small uk-margin" data-uk-grid>
          <div class="uk-width-auto">
            <div class="tm-user-menu-photo" :class="{'tm-sidebar-red-notification':needVerification}" :style="{ backgroundImage: `url(${avatar})` }"></div>
          </div>
          <div class="uk-width-expand">
            <div class="tm-user-menu-info">
              <!--Имя юзера-->
              <div class="tm-user-info-name uk-light">
                {{ title }}
              </div>
              <!--Роль юзера-->
              <div class="tm-user-menu-photo-role" v-if="role !== null">
                {{ role }} | {{user_id}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Уведомление о незаполненном профайле-->
      <div
          v-if="needVerification"
          class="uk-dropdown tm-dropdown tm-dropdown-bottom-left uk-text-center"
          style="width: 260px;max-width: 260px;"
          data-uk-dropdown="pos: bottom-left; offset: 15; delay-show: 300">
        {{ location_keys.tooltip_need_profile_fill }}
      </div>
    </div>


    <ul class="uk-nav uk-nav-default">
      <!--Профайл юзера-->
      <li :class="{ active: isActive() }">
        <a class="nav-link" @click="goToProfile">
          <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
            <div>
              <md-icon>person</md-icon>
            </div>
            <div class="uk-width-expand">
              {{ location_keys.menu_my_profile }}
            </div>
          </div>
        </a>
      </li>
      <!--logout-->
      <li>
        <a class="nav-link" @click="logout">
          <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
            <div>
              <md-icon>logout</md-icon>
            </div>
            <div class="uk-width-expand">
              {{ location_keys.menu_logout }}
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      role: '',
      isClosed: true,
      title: 'Profile',
      rtlTitle: "تانيا أندرو",
      location_keys: {},
      avatar: '',
      email: '',
      user_id: null,
      getterKey: 0,
      needVerification: true
    };
  },
  async created() {
    this.getLocalizationDashBoard();
    this.$store.watch(() => this.$store.getters["profile/me"](0), (me) => {
      this.title = me.name;
      this.role = me.role;
      this.email = me.email;
      this.user_id = me.id;
      this.avatar = me.avatar ? me.avatar : process.env.VUE_APP_BASE_URL + "/img/faces/marc.jpg";
      this.needVerification = me.profile.needVerification && ['retoucher', 'pro-retoucher'].indexOf(this.role) !== -1;

    })
    await this.$store.dispatch("profile/me")
    await this.$store.dispatch("profile/role")
  },
  methods: {
    async getLocalizationDashBoard() {
      await this.$store.dispatch("localization/dashBoardLocal");
      this.location_keys = await this.$store.getters["localization/dashBoardLocal"];
    },
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
    goToProfile() {
      this.$router.push({name: "User Profile"})
    },
    logout() {
      this.$store.dispatch("logout");
    },
    isActive() {
      return this.$route.path === '/user-profile';
    }
  }
}
</script>
<style>
  .tm-user-menu-avatar .tm-dropdown-bottom-left:after {
    left: 15px;
  }
  .tm-user-menu-avatar {
    padding: 20px 20px 10px;
  }
  .tm-user-menu-photo {
    width: 40px;
    height: 40px;
    border-radius: 40px;;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .tm-user-menu-photo-role {
    display: inline-block;
    padding: 2px 7px;
    border-radius: 10px;
    background-color: #fff;
    color: #333;
    margin-top: 5px;
    font-weight: 400;
    font-size: 10px;
  }
</style>
